"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = sendPostBackToPostActivitySaga;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _effects = require("redux-saga/effects");

var _postActivity = _interopRequireDefault(require("../actions/postActivity"));

var _sendPostBack = require("../actions/sendPostBack");

var _whileConnected = _interopRequireDefault(require("./effects/whileConnected"));

var _marked = /*#__PURE__*/_regenerator["default"].mark(postActivityWithPostBack),
    _marked2 = /*#__PURE__*/_regenerator["default"].mark(sendPostBackToPostActivity),
    _marked3 = /*#__PURE__*/_regenerator["default"].mark(sendPostBackToPostActivitySaga);

// https://github.com/microsoft/botframework-sdk/blob/main/specs/botframework-activity/botframework-activity.md#post-back
function postActivityWithPostBack(_ref) {
  var value;
  return _regenerator["default"].wrap(function postActivityWithPostBack$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          value = _ref.payload.value;
          _context.next = 3;
          return (0, _effects.put)((0, _postActivity["default"])({
            channelData: {
              postBack: true
            },
            text: typeof value === 'string' ? value : undefined,
            type: 'message',
            value: typeof value !== 'string' ? value : undefined
          }));

        case 3:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

function sendPostBackToPostActivity() {
  return _regenerator["default"].wrap(function sendPostBackToPostActivity$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.takeEvery)(_sendPostBack.SEND_POST_BACK, postActivityWithPostBack);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}

function sendPostBackToPostActivitySaga() {
  return _regenerator["default"].wrap(function sendPostBackToPostActivitySaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _whileConnected["default"])(sendPostBackToPostActivity);

        case 2:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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